import React, { useState } from 'react'
import { SessionsList } from './SessionsList'
import { PresenceManagement } from './PresenceManagement'
import { Session } from '../types/database'

export function PresencesList() {
  const [selectedSession, setSelectedSession] = useState<Session | null>(null)

  if (selectedSession) {
    return (
      <PresenceManagement
        session={selectedSession}
        onBack={() => setSelectedSession(null)}
      />
    )
  }

  return (
    <SessionsList onSelectSession={setSelectedSession} />
  )
}